import {TimeZoneShift} from '../types';
import {correctTimeStamp} from '../correctTimeStamp';

export function correctTimeZoneDependentDates(
  state: StorableState,
  shift: TimeZoneShift
): StorableState {
  const {budget, lastRecalcDateTime} = state;
  const {startDate, finishDate} = budget;

  return {
    ...state,
    lastRecalcDateTime: correctTimeStamp(lastRecalcDateTime, shift),
    budget: {
      ...budget,
      startDate: correctTimeStamp(startDate, shift),
      finishDate: correctTimeStamp(finishDate, shift),
    },
  };
}
